import { Medication, Prescription } from '../models';
import { IdentifierType } from '../../common';

export function canDisplayPrescription(prescription: Prescription): boolean {
  const regex = /VIDIS_[0367]\d{3}/;
  return !prescription?.errors?.some(error => regex.test(error?.code)) && prescription?.medications != null && prescription.medications.length > 0;
};

export function isCompound(medication: Medication) : boolean {
  return medication?.identifier?.type === IdentifierType.COMPOUND;
}
